<template>
  <section class="programari">

    <main-modal />

    <pacient-header />

    <ul class="lista-history"
        cy="lista-programari">
      <li class="relative"
          :class="{pointer: item.send_same_day_sms}"
          @click="Handle_Edit(item)"
          v-for="item in pacient.icalendar"
          :key="item.id">

        <div class="flex flex-between h100">
          <div>
            <h4>Dr. {{ item.doctor }}
              <span>{{ Format_Time(item.hour) }}:{{ Format_Time(item.minute) }} - {{ Convert_Duration_To_Time(item) }}</span>
            </h4>
            <span>{{ moment(item.date).format('DD MMM YYYY') }}</span>
          </div>
        </div>
      </li>
    </ul>

    <button @click="Show_Modal_For_Appointment"
            cy="add-programare-btn"
            class="bg-transparent flex-auto noborder flex m-left-auto pointer">
      <i v-html="svg.addPacient" />
    </button>

  </section>

</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import { checkObjProps } from '../store/utils'
  export default {
    name: 'programari',
    data () {
      return {
        moment,
        checkObjProps
      }
    },
    computed: {
      ...mapState({
        svg: 'svg',
        pacient: 'pacient',
      })
    },
    methods: {
      Show_Modal_For_Appointment () {
        this.$store.commit('SET_SHOW_MODAL_PROGRAMARI', true);
      },
      Format_Time (value) {
        return +value < 10 ? `0${value}` : value;
      },
      Convert_Duration_To_Time (item) {
        const { hour, minute, duration_hour, duration_minute } = item;
        const totalMinutes =
          Number(hour) * 60 +
          Number(minute) +
          Number(duration_hour) * 60 +
          Number(duration_minute);

        const h = Math.floor(totalMinutes / 60) % 24;
        const m = totalMinutes % 60;

        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      },
      Handle_Edit (data) {
        this.$store.commit('SET_APPOINTMENT_DATA', { ...data });
        this.Show_Modal_For_Appointment();
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/styles/var";
  .programari {
    padding-top: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    .lista-history li {
      padding-left: 36px;
      cursor: pointer;
      &:hover {
        background-color: @light-grey;
      }
    }

    svg #Oval {
      transition: fill .2s ease-in-out;
    }

    button.noborder {
      margin-top: auto;
    }

    button.noborder:hover {
      svg #Oval {
        fill: darken(@main-green, 20%, relative);
      }
    }
  }
</style>
